export const getCurrentMealType = (state, props) => {
  if (!state.catering) return null;
  const mealTypeList = state.catering.mealTypeList.get('data');
  return mealTypeList
    ? mealTypeList.find(
        mealType => mealType.get('id') === Number(props.params.mealTypeId),
      )
    : null;
};
